module.exports = __webpack_public_path__ + "static/media/builtinv2-proverka elctro.d8a28d4c.png";